import * as React from "react";
import { makeStyles, Button } from "@fluentui/react-components";

/**
 * Interface définissant les propriétés du composant Accueil.
 */
export interface AccueilProps {
  setCurrentView: (view: string) => void;
}

/**
 * Composant Accueil : représente la page d'accueil de l'application.
 * Permet à l'utilisateur de se connecter ou de créer un compte.
 */
const Accueil: React.FC<AccueilProps> = (props: AccueilProps) => {
  const styles = useStyles();

  /**
   * Fonction appelée lorsque l'utilisateur clique sur "Se connecter".
   * Change la vue actuelle vers la page de connexion.
   */
  const handleConnect = () => {
    props.setCurrentView("Connexion");
  };

  /**
   * Fonction appelée lorsque l'utilisateur clique sur "Créer un compte".
   * Change la vue actuelle vers la page de création de compte.
   */
  const handleCreateAccount = () => {
    props.setCurrentView("SignupPage");
  };

  return (
    <div className={styles.container}>
      {/* Titre de la page */}
      <h1 className={styles.title}>Bienvenue à IA pour Excel</h1>

      {/* Bouton pour se connecter */}
      <Button appearance="primary" className={styles.greenButton} onClick={handleConnect}>
        Se connecter
      </Button>

      {/* Bouton pour créer un compte */}
      <Button appearance="primary" className={styles.button} onClick={handleCreateAccount}>
        Créer un compte
      </Button>
    </div>
  );
};

export default Accueil;

const useStyles = makeStyles({
  container: {
    padding: "20px",
    textAlign: "center",
  },
  title: {
    fontSize: "32px",
    fontWeight: "bold",
    lineHeight: "30px",
    marginBottom: "20px",
  },
  button: {
    width: "100%",
    margin: "5px 0",
  },
  greenButton: {
    width: "100%",
    margin: "5px 0",
    backgroundColor: "#217346",
    color: "white",
    "&:hover": {
      backgroundColor: "#1e6d43",
    },
  },
});
